// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2u6hV","list":"BalanceDue_list__1h_Kj","listRow":"BalanceDue_listRow__2dfu4","total":"BalanceDue_total__F0BtA"};